import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=29d68065&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"
import style0 from "./Messages.vue?vue&type=style&index=0&id=29d68065&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d68065",
  null
  
)

export default component.exports